import ActivityContainer from './activity-container';

export default ActivityContainer;
